import { useEffect, useRef } from "react";
import App from "./App";

export default function TV() {
  const audioRef = useRef(null);
  const streamUrl = "https://radyo.duhnet.tv/slowturk?/;stream.mp3="; // Sağlanan yayın linki

  useEffect(() => {
    document.title = "Buğra Toprak Kuyumculuk - Fiyat Ekranı";

    const tryPlay = async () => {
      const el = audioRef.current;
      if (!el) return;
      try {
        await el.play();
      } catch (err) {
        // Autoplay engellenirse alternatif bir Audio elemanı ile tekrar dene
        try {
          const alt = new Audio(streamUrl);
          alt.autoplay = true;
          alt.loop = true;
          alt.crossOrigin = "anonymous";
          alt.playsInline = true;
          alt.hidden = true;
          document.body.appendChild(alt);
          audioRef.current = alt;
          await alt.play();
        } catch (err2) {
          // Bazı tarayıcılar kullanıcı etkileşimi olmadan sesli autoplay'e izin vermez
          // TV/kiosk modunda tarayıcı ayarlarından autoplay'e izin vermek gerekebilir.
        }
      }
    };

    const t = setTimeout(tryPlay, 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {/* Arka planda çalan radyo - görünmez */}
      <audio
        ref={audioRef}
        src={streamUrl}
        autoPlay
        preload="auto"
        loop
        playsInline
        style={{ display: "none" }}
      />
      {/* Normal fiyat ekranı aynen gösteriliyor */}
      <App isTVMode={true} />
    </>
  );
}
